import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import OptionsConstants from '../../../constants/other-shipping-options-constants';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import CompactError from '../../compact-error/index';
import FormattedCurrency from '../../formatted-currency/container';
import { THIRD_PARTY, RECIPIENT } from '../../../enums/bill-to-party';
import { messages } from './messages';

import style from './rate.module.less';

const RateColumn = ({ fulfillmentPlanId }) => {
  const { rateIsProcessing, rateSummary, labelConfiguration } = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId }),
  );
  const { rate, rateError } = rateSummary ?? {};
  const { totalCost } = rate ?? {};
  const serviceId = labelConfiguration?.serviceId;
  const service = useSelector((state) => Global.selectSellerServiceById(state, { serviceId }));
  const { billToParty } = labelConfiguration?.options?.billToAccount ?? {};
  const isThirdPartyBilling =
    service?.optionCodes?.includes(OptionsConstants.billToThirdParty) && (billToParty === THIRD_PARTY || billToParty === RECIPIENT);
  const rateErrorsArray = useMemo(() => [rateError], [rateError]);

  if (rateIsProcessing) {
    return <LoadingIndicator theme='grey' />;
  }

  if (rateError) {
    return (
      <div className={style['rate-error-wrapper']}>
        <CompactError
          className='column-warning'
          errorMessages={rateErrorsArray}
          preferPlace='bottom'
          title={<FormattedMessage {...messages.rateWarningTitle} />}
        />
      </div>
    );
  }

  if (totalCost?.value === 0 || isThirdPartyBilling) {
    return null;
  }

  return (
    <div className={style['rate-column']}>
      <FormattedCurrency currentCode={totalCost.code} value={totalCost.value} />
    </div>
  );
};

RateColumn.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export const Rate = {
  getMessageDescriptor: () => messages.rate,
  id: 'rate',

  render: (data, { isExpanded = false, isFirstRow = true } = {}) => {
    if (!isFirstRow) {
      return null;
    }

    return <RateColumn fulfillmentPlanId={data.id} isExpanded={isExpanded} />;
  },
};
